module.exports = __webpack_public_path__ + "img/hotelFamily-9.1ff2f53d.jpg";